import { ReactElement, useContext } from 'react';
import './ErrorPage.less';
import { FormattedMessage } from 'react-intl';
import { Button } from 'antd';
import { SessionContext } from 'auth/SessionProvider';
import ErrorPageLogo from 'images/error-page-logo.svg?react';
import IncortaLogo from 'images/incorta-blue-logo.svg?react';

type Props = {
  headerContent: ReactElement;
  subheaderContent: ReactElement;
  onReturnToLoginPage?: () => void;
};
function ErrorPage(props: Props) {
  const { logout } = useContext(SessionContext);

  function handleReturnToLoginPage() {
    logout({ returnTo: window.location.origin });
  }

  return (
    <div className="error-page__wrapper">
      <section className="error-page__info">
        <IncortaLogo className="error-page__incorta-logo" />
        <h2 className="error-page__header">{props.headerContent}</h2>
        <label className="error-page__sub-header">
          {props.subheaderContent}
        </label>
        <Button
          className="error-page__home-page-button"
          size="large"
          onClick={props.onReturnToLoginPage ?? handleReturnToLoginPage}
          type="primary"
        >
          <FormattedMessage id="auth0.errorPages.general.returnToLoginPageButton" />
        </Button>
      </section>
      <section className="error-page__logo-wrapper">
        <ErrorPageLogo className="error-page__logo" />
      </section>
    </div>
  );
}

export default ErrorPage;
